export const APPEARANCE_SETTINGS_MENU_BUTTON_LABEL = "Appearance";
export const APPEARANCE_SETTINGS_MODAL_HEADER_LABEL = "Appearance Settings";
export const THEME_SECTION_HEADER_LABEL = "THEME";
export const LIGHT_MODE_LABEL = "Light Mode";
export const DARK_MODE_LABEL = "Dark Mode";
export const FOCUS_MODE_SECTION_HEADER_LABEL = "FOCUS MODE";
export const HIDE_ELEMENTS_SETTING_LABEL = "Hide Elements";
export const HIDE_ELEMENTS_SETTING_IDLE_TIMEOUT_LABEL = "Hide After (seconds)";
export const FOCUS_MODE_DEFAULT_TIMEOUT_MS = 30000; // 30 seconds
export const FOCUS_MODE_TIMEOUT_MIN_MS = 1000; // 1 seconds
export const FOCUS_MODE_TIMEOUT_MAX_MS = 600000; // 10 minutes
